<template>
  <v-data-table
    class="clickable-table"
    :headers="headers"
    :items="rules"
    :must-sort="false"
    disable-pagination
    hide-default-footer
    mobile-breakpoint="0"
    @click:row="edit"
  >
    <template #item.eventType.text="props">
      <span :class="props.item.isInactive ? 'grey--text' : ''">{{ props.item.eventType.text }}</span>
    </template>

    <template #item.messageType.text="props">
      <span :class="props.item.isInactive ? 'grey--text' : ''">{{ props.item.messageType.text }}</span>
    </template>

    <template #item.campaign.description="props">
      <template v-if="props.item.campaign">
        <span :class="props.item.isInactive ? 'grey--text' : ''">{{ props.item.campaign.description }}</span>
      </template>
      <span
        v-else
        :class="props.item.isInactive ? 'grey--text' : 'text--secondary'"
      >({{ $i18n.t('label.table_value_any') }})</span>
    </template>

    <template #item.service.title="props">
      <template v-if="props.item.service">
        <span :class="props.item.isInactive ? 'grey--text' : ''">{{ props.item.service.title }}</span>
      </template>
      <span
        v-else
        :class="props.item.isInactive ? 'grey--text' : 'text--secondary'"
      >({{ $i18n.t('label.table_value_any') }})</span>
    </template>

    <template #item.tab.name="props">
      <template v-if="props.item.tab">
        <span :class="props.item.isInactive ? 'grey--text' : ''">{{ props.item.tab.name }}</span>
      </template>
      <span
        v-else
        :class="props.item.isInactive ? 'grey--text' : 'text--secondary'"
      >({{ $i18n.t('label.table_value_any') }})</span>
    </template>

    <template #item.isInactive="props">
      <v-chip
        v-if="!props.item.isInactive"
        color="success"
        small
      >
        {{ $t('label.active') }}
      </v-chip>
      <v-chip
        v-else
        color="gray"
        small
      >
        {{ $t('label.inactive') }}
      </v-chip>
    </template>
  </v-data-table>
</template>

<script lang="ts">
import MessageRule from '@/model/MessageRule';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'MessageCenterRulesTable',
  components: { },
  mixins: [],
  props: {
    rules: { type: Object as PropType<Array<MessageRule>>, required: true },
    showDetails: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
    };
  },
  computed: {
    headers(): any[] {
      const headers : any[] = [
        {
          text: this.$i18n.t('label.event_type'),
          value: 'eventType.text',
          align: 'start',
          sortable: true,
        },
      ];

      if (this.showDetails) {
        headers.push(
          {
            text: this.$i18n.t('label.campaign'),
            value: 'campaign.description',
            align: 'center',
            sortable: true,
          },
          {
            text: this.$i18n.t('label.service'),
            value: 'service.title',
            align: 'center',
            sortable: true,
          },
          {
            text: this.$i18n.t('label.section'),
            value: 'tab.name',
            align: 'center',
            sortable: true,
          },
        );
      }

      headers.push(
        {
          text: this.$i18n.t('title.message_type'),
          value: 'messageType.text',
          align: 'center',
          sortable: true,
          width: '140px',
        },
        {
          text: this.$i18n.t('label.active'),
          value: 'isInactive',
          align: 'center',
          sortable: true,
          width: '100px',
          sort: (a: boolean, b: boolean) => Number(!!a) - Number(!!b),
        },
      );
      return headers;
    },
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    edit(o: any, prop: any) {
      if (o.isDisabled) return;
      this.$emit('row-clicked', o);
    },
  },
});
</script>
